import React, { useState, useEffect } from "react";
import {
  FaArrowLeft,
  FaEdit,
  FaList,
  FaTimes,
  FaArrowUp,
  FaArrowsAltV,
  FaArrowDown,
} from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import "./faq_style.css";
import { useQuill } from "react-quilljs";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { Modal, Spinner } from "react-bootstrap";
import DOMPurify from "dompurify";

function Faq() {
  const [vista, setVista] = useState("niveles");
  const [idSelect, setIdSelect] = useState("");

  //issues
  const [issuesEs, setIssuesEs] = useState([]);
  const [issuesEn, setIssuesEn] = useState([]);

  //Categorias
  const [category, setCategory] = useState([]);
  const [levelUpName, setLevelUpName] = useState("");

  //Request
  const [request, setRequest] = useState([]);
  const [categoryName, setCategoryName] = useState("");

  const [showModal, setShowModal] = useState(false);

  const getIssues = async () => {
    try {
      const headers = {
        Authorization: process.env.REACT_APP_PUBLIC_KEY,
      };

      const urls = [
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/lang/es`,
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/lang/en`,
      ];

      const [resEs, resEn] = await Promise.all(
        urls.map((url) => axios.get(url, { headers }))
      );

      setIssuesEs(resEs.data.data);
      setIssuesEn(resEn.data.data);
    } catch (error) {
      console.error("Error al obtener issues:", error);
    }
  };

  const createIssues = async () => {
    const swalHtml = `
    <div class="form-grid">
      <label><font size="3">Nombre en español</font></label>
      <input type="text" id="level1" class="swal2-input" placeholder="Nivel 1" />
      <label><font size="3">Nombre en inglés</font></label>
      <input type="text" id="level1_en" class="swal2-input" placeholder="Level 1" />
    </div>
  `;

    try {
      const result = await Swal.fire({
        title: "Agregar Issues",
        html: swalHtml,
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          const nameEs = document.getElementById("level1").value.trim();
          const nameEn = document.getElementById("level1_en").value.trim();

          if (!nameEs || !nameEn) {
            Swal.showValidationMessage("Ambos campos son obligatorios");
            return false;
          }

          return { nameEs, nameEn };
        },
      });

      if (result.isConfirmed) {
        const { nameEs, nameEn } = result.value;
        const headers = {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        };

        await Promise.all([
          axios.post(
            `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/create/es`,
            { name: nameEs },
            { headers }
          ),
          axios.post(
            `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/create/en`,
            { name: nameEn },
            { headers }
          ),
        ]);

        await Swal.fire(
          "¡Creado!",
          "El Issues ha sido creado exitosamente.",
          "success"
        );
        getIssues();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Acción cancelada.", "info");
      }
    } catch (error) {
      console.error("Error al crear el Issues:", error);
      Swal.fire("Error", "No se pudo crear el Issues.", "error");
    }
  };

  const createCategorie = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/${idSelect}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );

      if (response.data.code === 1) {
        const { data } = response.data;

        const result = await Swal.fire({
          title: `Agregar una categoria para ${data.name}`,
          html:
            '<div class="form-grid">' +
            '<font size="3">Categoria</font><br />' +
            '<input type="text" id="categorie" class="swal2-input" style="margin-top: 0px;" placeholder="Categoria"><br /><br />' +
            "</div>",
          showCancelButton: true,
          confirmButtonText: "Crear",
          cancelButtonText: "Cancelar",
          preConfirm: () => {
            const categorie = document.getElementById("categorie").value.trim();

            if (!categorie) {
              Swal.showValidationMessage("campos son obligatorios");
              return false;
            }

            return categorie;
          },
        });

        if (result.isConfirmed) {
          const response = await axios.post(
            `${process.env.REACT_APP_URL_BACKEND}/api/qfa/category/create/${data.lgn}/${data.id}`,
            { name: result.value },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          if (response.data.code === 1) {
            Swal.fire(
              "¡Creado!",
              "La categoria ha sido creada exitosamente.",
              "success"
            );
          } else {
            Swal.fire(
              "¡error!",
              "Hubo un error por favor intenta de nuevo",
              "error"
            );
          }

          handleShowCategories(data.id, data.lgn, data.name);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelado", "Accion cancelada.", "error");
        }
      } else {
        throw new Error(response);
      }
    } catch (error) {
      console.error("Error al crear la categoría:", error);
      Swal.fire(
        "Error al crear categoria",
        "No se ha creado ninguna categoria"
      );
    }
  };

  const createRequesst = async () => {
    let quillInstance;
    let selectedFile = null;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/category/${idSelect}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );

      if (response.data.code !== 1) throw new Error("Categoría no encontrada");

      const { data } = response.data;

      const result = await Swal.fire({
        title: "Agregar Pregunta",
        html: `
        <div class="form-grid">
          <font size="3">Pregunta</font><br />
          <input type="text" id="question" class="swal2-input" style="margin-bottom: 20px; margin-top: 0px;" placeholder="Pregunta"><br />
          <font size="3">Respuesta</font><br />
          <div id="editorContainer" style="height: 150px; border: 1px solid black; padding: 5px; border-radius: 5px;"></div>
          <font size="3">Archivo</font><br />
          <input type="file" id="fileUpload" class="swal2-input"><br /><br />
        </div>
      `,
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        didOpen: () => {
          quillInstance = new Quill("#editorContainer", {
            theme: "snow",
            placeholder: "Escribe tu respuesta aquí...",
            modules: {
              toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["blockquote", "code-block"],
                [{ align: [] }],
                ["clean"],
              ],
            },
          });

          document
            .getElementById("fileUpload")
            .addEventListener("change", (event) => {
              selectedFile = event.target.files[0];
            });
        },
        preConfirm: () => {
          const question = document.getElementById("question").value.trim();
          const answer = quillInstance.root.innerHTML.trim();

          if (!question || !answer) {
            Swal.showValidationMessage(
              "La pregunta y respuesta son obligatorias."
            );
            return false;
          }

          return { question, answer };
        },
      });

      if (!result.isConfirmed) {
        Swal.fire("Cancelado", "Acción cancelada.", "info");
        return;
      }

      const formDataEs = new FormData();
      formDataEs.append("name", result.value.question);
      formDataEs.append("question", result.value.question);
      formDataEs.append("answers", result.value.answer);
      if (selectedFile) formDataEs.append("file", selectedFile);

      const createRes = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/question/create/${data.lgn}/${data.id}`,
        formDataEs,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            // NO pongas 'Content-Type' aquí, Axios lo pone solo cuando usas FormData
          },
        }
      );

      if (createRes.data.code === 1) {
        Swal.fire(
          "¡Creado!",
          "La pregunta ha sido creada correctamente.",
          "success"
        );
        handleShowRequest(data.id, data.lgn, data.name);
      } else {
        throw new Error("No se pudo crear la pregunta");
      }
    } catch (error) {
      console.error("Error al crear la pregunta:", error);
      Swal.fire(
        "Error",
        "No se pudo crear la pregunta. Intenta de nuevo.",
        "error"
      );
    }
  };

  const deleteItem = async (id, endpoint, nombre) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        const response = await axios.delete(
          `${process.env.REACT_APP_URL_BACKEND}${endpoint}/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (response.data.code === 1) {
          Swal.fire("¡Eliminado!", `${nombre} ha sido eliminado.`, "success");
        } else {
          Swal.fire("Error", "No se pudo eliminar correctamente.", "error");
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", `${nombre} está a salvo :)`, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error al eliminar.", "error");
      console.error(error);
    }
  };

  const editIssues = async (id) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/${id}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );

      if (res.data.code === 1) {
        const { data } = res.data;
        const swalHtml = `
          <div class="form-grid">
            <label><font size="3">Nombre</font></label>
            <input type="text" id="level1" class="swal2-input" placeholder="Nivel 1" value="${data.name}"/>
          </div>
        `;

        const result = await Swal.fire({
          title: "Editar Issues",
          html: swalHtml,
          showCancelButton: true,
          confirmButtonText: "Editar",
          cancelButtonText: "Cancelar",
          preConfirm: () => {
            const nameEs = document.getElementById("level1").value.trim();

            if (!nameEs) {
              Swal.showValidationMessage("Ambos campos son obligatorios");
              return false;
            }

            return { nameEs };
          },
        });

        if (result.isConfirmed) {
          const { nameEs } = result.value;
          const headers = {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          };

          await axios.put(
            `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/update/${id}`,
            { name: nameEs },
            { headers }
          );

          await Swal.fire(
            "Editado!",
            "El Issues ha sido Actualizado exitosamente.",
            "success"
          );
          getIssues();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelado", "Acción cancelada.", "info");
        }
      } else {
        Swal.fire("Error", "Nivel 1 No encontrado", "error");
      }
    } catch (error) {
      console.error("Error al crear el Issues:", error);
      Swal.fire("Error", "No se pudo crear el Issues.", "error");
    }
  };

  const editCategorie = async (id) => {
    try {
      const { data: resData } = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/category/${id}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );

      if (resData.code !== 1) {
        return Swal.fire("Error", "Categoría no encontrada", "error");
      }

      const { data } = resData;

      const { isConfirmed, value, dismiss } = await Swal.fire({
        title: `Editar categoría para ${data.name}`,
        html: `
        <div class="form-grid">
          <label><font size="3">Categoría</font></label><br />
          <input type="text" id="categorie" class="swal2-input" placeholder="Categoría" value="${data.name}" />
        </div>`,
        showCancelButton: true,
        confirmButtonText: "Actualizar",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          const categorie = document.getElementById("categorie").value.trim();
          if (!categorie) {
            Swal.showValidationMessage("El campo es obligatorio");
            return false;
          }
          return categorie;
        },
      });

      if (isConfirmed) {
        const updateResponse = await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/api/qfa/category/update/${id}`,
          { name: value },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (updateResponse.data.code === 1) {
          Swal.fire("Editado", "La categoría ha sido actualizada.", "success");

          const sectionResponse = await axios.get(
            `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/${data.section_id}`,
            {
              headers: {
                Authorization: process.env.REACT_APP_PUBLIC_KEY,
              },
            }
          );

          const levelUp = sectionResponse.data.data;
          handleShowCategories(levelUp.id, levelUp.lgn, levelUp.name);
        } else {
          Swal.fire("Error", "Error al actualizar la categoría", "error");
        }
      } else if (dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Acción cancelada.", "info");
      }
    } catch (error) {
      console.error("Error al editar la categoría:", error);
      Swal.fire("Error", "No se ha podido editar la categoría", "error");
    }
  };

  const editRequesst = async (id) => {
    let quillInstance;
    let selectedFile = null;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/question/${id}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );

      if (response.data.code !== 1) throw new Error("Respuesta no encontrada");

      const { data } = response.data;

      const result = await Swal.fire({
        title: "Editar Pregunta",
        html: `
        <div class="form-grid">
          <font size="3">Pregunta</font><br />
          <input type="text" id="question" class="swal2-input" style="margin-bottom: 20px; margin-top: 0px;" placeholder="Pregunta" value="${
            data.question
          }"><br />
          <font size="3">Respuesta</font><br />
          <div id="editorContainer" style="height: 150px; border: 1px solid black; padding: 5px; border-radius: 5px;"></div>
          <font size="3">Archivo</font><br />
          <input type="file" id="fileUpload" class="swal2-input"><br /><br />
          ${
            data.file_url
              ? `<span id="fileLabel">Archivo actual: ${data.file_url
                  .split("/")
                  .pop()}</span><br/><br/>`
              : ""
          }
        </div>
      `,
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        didOpen: () => {
          quillInstance = new Quill("#editorContainer", {
            theme: "snow",
            placeholder: "Escribe tu respuesta aquí...",
            modules: {
              toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["blockquote", "code-block"],
                [{ align: [] }],
                ["clean"],
              ],
            },
          });

          quillInstance.root.innerHTML = data.answers;

          document
            .getElementById("fileUpload")
            .addEventListener("change", (event) => {
              selectedFile = event.target.files[0];
            });
        },
        preConfirm: () => {
          const question = document.getElementById("question").value.trim();
          const answer = quillInstance.root.innerHTML.trim();

          if (!question || !answer) {
            Swal.showValidationMessage(
              "La pregunta y respuesta son obligatorias."
            );
            return false;
          }

          return { question, answer };
        },
      });

      if (!result.isConfirmed) {
        Swal.fire("Cancelado", "Acción cancelada.", "info");
        return;
      }

      const formDataEs = new FormData();
      formDataEs.append("name", result.value.question);
      formDataEs.append("question", result.value.question);
      formDataEs.append("answers", result.value.answer);
      if (selectedFile) formDataEs.append("file", selectedFile);

      const createRes = await axios.put(
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/question/update/${id}`,
        formDataEs,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (createRes.data.code === 1) {
        Swal.fire(
          "Editada!",
          "La pregunta ha sido Editada correctamente.",
          "success"
        );

        const response = await axios.get(
          `${process.env.REACT_APP_URL_BACKEND}/api/qfa/category/${data.category_id}`,
          {
            headers: {
              Authorization: process.env.REACT_APP_PUBLIC_KEY,
            },
          }
        );

        const levelUp = response.data.data;

        handleShowRequest(levelUp.id, levelUp.lgn, levelUp.name);
      } else {
        throw new Error("No se pudo editar la pregunta");
      }
    } catch (error) {
      console.error("Error al editar la pregunta:", error);
      Swal.fire(
        "Error",
        "No se pudo editar la pregunta. Intenta de nuevo.",
        "error"
      );
    }
  };

  /* Eventos para navegación entre vistas  */
  const handleShowCategories = async (level, lg, name) => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/category/forLevel/${
          lg === "es" ? "es" : "en"
        }/${level}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );

      if (response.data.code === 1) {
        // Ordenar las categorías según el order_map
        const sortedCategories = response.data.data.sort((a, b) => {
          const aOrder = a.order_map?.[level] || 0;
          const bOrder = b.order_map?.[level] || 0;
          return aOrder - bOrder;
        });

        setCategory(sortedCategories);
        setLevelUpName(name);
        setIdSelect(level);
        setVista("categorias");
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error obteniendo categorías:", error);
      Swal.fire("Error", "No se pudieron cargar las categorías", "error");
    }
  };

  const handleShowRequest = async (level, lg, name) => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/qfa/question/forLevel/${
          lg === "es" ? "es" : "en"
        }/${level}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );

      if (response.data.code === 1) {
        // Ordenar las respuestas según el order_map
        const sortedRequests = response.data.data.sort((a, b) => {
          const aOrder = a.order_map?.[level] || 0;
          const bOrder = b.order_map?.[level] || 0;
          return aOrder - bOrder;
        });

        setRequest(sortedRequests);
        setCategoryName(name);
        setIdSelect(level);
        setVista("preguntas");
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error obteniendo preguntas:", error);
      Swal.fire("Error", "No se pudieron cargar las preguntas", "error");
    }
  };

  const handleBackView = () => {
    if (vista === "preguntas") {
      setVista("categorias");
    } else if (vista === "categorias") {
      setVista("niveles");
    }
  };

  const moveItemUp = async (itemId, isCategory) => {
    try {
      const endpoint = isCategory
        ? `/api/qfa/categories/${idSelect}/order`
        : `/api/qfa/question/${idSelect}/order`;

      const currentItems = isCategory ? category : request;
      const currentIndex = currentItems.findIndex((item) => item.id === itemId);

      if (currentIndex <= 0) return; // Ya está en la primera posición

      const newPosition = currentIndex; // Mover arriba es posición actual -1

      const response = await axios.put(
        `${process.env.REACT_APP_URL_BACKEND}${endpoint}`,
        {
          [isCategory ? "categoryId" : "answerId"]: itemId,
          newPosition: newPosition,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.code === 1) {
        // Refrescar la vista
        if (isCategory) {
          const sectionResponse = await axios.get(
            `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/${idSelect}`,
            {
              headers: {
                Authorization: process.env.REACT_APP_PUBLIC_KEY,
              },
            }
          );
          const levelUp = sectionResponse.data.data;
          handleShowCategories(levelUp.id, levelUp.lgn, levelUp.name);
        } else {
          const categoryResponse = await axios.get(
            `${process.env.REACT_APP_URL_BACKEND}/api/qfa/category/${idSelect}`,
            {
              headers: {
                Authorization: process.env.REACT_APP_PUBLIC_KEY,
              },
            }
          );
          const levelUp = categoryResponse.data.data;
          handleShowRequest(levelUp.id, levelUp.lgn, levelUp.name);
        }
      }
    } catch (error) {
      console.error("Error moving item:", error);
      Swal.fire("Error", "No se pudo mover el elemento", "error");
    }
  };

  const moveItemDown = async (itemId, isCategory) => {
    try {
      const endpoint = isCategory
        ? `/api/qfa/categories/${idSelect}/order`
        : `/api/qfa/question/${idSelect}/order`;

      const currentItems = isCategory ? category : request;
      const currentIndex = currentItems.findIndex((item) => item.id === itemId);

      if (currentIndex >= currentItems.length - 1) return; // Ya está en la última posición

      const newPosition = currentIndex + 2; // Mover abajo es posición actual + 1

      const response = await axios.put(
        `${process.env.REACT_APP_URL_BACKEND}${endpoint}`,
        {
          [isCategory ? "categoryId" : "answerId"]: itemId,
          newPosition: newPosition,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.code === 1) {
        // Refrescar la vista
        if (isCategory) {
          const sectionResponse = await axios.get(
            `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/${idSelect}`,
            {
              headers: {
                Authorization: process.env.REACT_APP_PUBLIC_KEY,
              },
            }
          );
          const levelUp = sectionResponse.data.data;
          handleShowCategories(levelUp.id, levelUp.lgn, levelUp.name);
        } else {
          const categoryResponse = await axios.get(
            `${process.env.REACT_APP_URL_BACKEND}/api/qfa/category/${idSelect}`,
            {
              headers: {
                Authorization: process.env.REACT_APP_PUBLIC_KEY,
              },
            }
          );
          const levelUp = categoryResponse.data.data;
          handleShowRequest(levelUp.id, levelUp.lgn, levelUp.name);
        }
      }
    } catch (error) {
      console.error("Error moving item:", error);
      Swal.fire("Error", "No se pudo mover el elemento", "error");
    }
  };

  const changePosition = async (itemId, isCategory) => {
    try {
      // Obtener las posiciones disponibles
      const positionsEndpoint = isCategory
        ? `/api/qfa/categories/${idSelect}/positions`
        : `/api/qfa/question/${idSelect}/positions`;

      let positions = [];

      try {
        const positionsResponse = await axios.get(
          `${process.env.REACT_APP_URL_BACKEND}${positionsEndpoint}`,
          {
            headers: {
              Authorization: process.env.REACT_APP_PUBLIC_KEY,
            },
          }
        );

        if (positionsResponse.data.code === 1) {
          positions = positionsResponse.data.positions;
        } else {
          // Si falla la API, generar posiciones basadas en los items actuales
          const currentItems = isCategory ? category : request;
          positions = Array.from(
            { length: currentItems.length },
            (_, i) => i + 1
          );
        }
      } catch (error) {
        console.error("Error getting positions, using fallback:", error);
        const currentItems = isCategory ? category : request;
        positions = Array.from(
          { length: currentItems.length },
          (_, i) => i + 1
        );
      }

      const { value: selectedPosition } = await Swal.fire({
        title: "Seleccionar nueva posición",
        input: "select",
        inputOptions: positions.reduce((acc, pos) => {
          acc[pos] = `Posición ${pos}`;
          return acc;
        }, {}),
        inputPlaceholder: "Selecciona una posición",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "Debes seleccionar una posición";
          }
        },
      });

      if (selectedPosition) {
        const endpoint = isCategory
          ? `/api/qfa/categories/${idSelect}/order`
          : `/api/qfa/question/${idSelect}/order`;

        const response = await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}${endpoint}`,
          {
            [isCategory ? "categoryId" : "answerId"]: itemId,
            newPosition: selectedPosition,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (response.data.code === 1) {
          Swal.fire("Éxito", "Posición actualizada correctamente", "success");
          // Refrescar la vista
          if (isCategory) {
            const sectionResponse = await axios.get(
              `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/${idSelect}`,
              {
                headers: {
                  Authorization: process.env.REACT_APP_PUBLIC_KEY,
                },
              }
            );
            const levelUp = sectionResponse.data.data;
            handleShowCategories(levelUp.id, levelUp.lgn, levelUp.name);
          } else {
            const categoryResponse = await axios.get(
              `${process.env.REACT_APP_URL_BACKEND}/api/qfa/category/${idSelect}`,
              {
                headers: {
                  Authorization: process.env.REACT_APP_PUBLIC_KEY,
                },
              }
            );
            const levelUp = categoryResponse.data.data;
            handleShowRequest(levelUp.id, levelUp.lgn, levelUp.name);
          }
        }
      }
    } catch (error) {
      console.error("Error changing position:", error);
      Swal.fire("Error", "No se pudo cambiar la posición", "error");
    }
  };

  /* Buscador */
  const handleSearch = () => {
    console.log("Boton de buscar");
  };

  useEffect(() => {
    getIssues();
  }, []);

  return (
    <>
      <div className="table-responsive">
        {/* Vista de niveles 1 */}
        {vista === "niveles" && (
          <>
            <h3 style={{ color: "#020c41" }}>Niveles 1</h3>
            <div className="panel-table">
              <div className="colum-left">
                <input
                  type="text"
                  className="searchInput"
                  id="searchInput"
                  placeholder="Buscar..."
                />
                <button className="btnn" onClick={handleSearch}>
                  Buscar
                </button>
              </div>
              <div className="colum-rigth">
                <button className="btnn" onClick={createIssues}>
                  Agregar Nivel 1
                </button>
              </div>
            </div>

            <table className="table table-preve" id="tableToSearch">
              {/* Español */}
              <thead>
                <tr>
                  <th colSpan={3} style={{ backgroundColor: "#f2f2f2" }}>
                    🌐 Español
                  </th>
                </tr>
                <tr>
                  <th style={{ width: "45%" }}>Nombre</th>
                  <th style={{ width: "40%" }}>Fecha de creación</th>
                  <th className="accions" style={{ width: "15%" }}>
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                {issuesEs.map((level) => (
                  <tr key={level.id} data-master-id={level.id}>
                    <td>{level.name}</td>
                    <td>{level.created_at}</td>
                    <td>
                      <FaEdit
                        className="editButton"
                        onClick={() => editIssues(level.id)}
                      />
                      <FaTimes
                        className="deleteButton"
                        onClick={() =>
                          deleteItem(
                            level.id,
                            "/api/qfa/issues/delete",
                            "El nivel 1"
                          )
                        }
                      />
                      <FaList
                        className="folderButton"
                        onClick={() =>
                          handleShowCategories(level.id, level.lgn, level.name)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>

              {/* Inglés */}
              <thead>
                <tr>
                  <th colSpan={3} style={{ backgroundColor: "#f2f2f2" }}>
                    🇬🇧 English
                  </th>
                </tr>
                <tr>
                  <th style={{ width: "45%" }}>Nombre</th>
                  <th style={{ width: "40%" }}>Fecha de creación</th>
                  <th className="accions" style={{ width: "15%" }}>
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                {issuesEn.map((level) => (
                  <tr key={level.id} data-master-id={level.id}>
                    <td>{level.name}</td>
                    <td>{level.created_at}</td>
                    <td>
                      <FaEdit
                        className="editButton"
                        onClick={() => editIssues(level.id)}
                      />
                      <FaTimes
                        className="deleteButton"
                        onClick={() =>
                          deleteItem(
                            level.id,
                            "/api/qfa/issues/delete",
                            "El nivel 1"
                          )
                        }
                      />
                      <FaList
                        className="folderButton"
                        onClick={() =>
                          handleShowCategories(level.id, level.lgn, level.name)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {/* Vista de categorias */}
        {vista === "categorias" && (
          <>
            <div className="panel-table">
              <div className="colum-left">
                <button
                  onClick={handleBackView}
                  className="btnn"
                  style={{ marginBottom: "10px" }}
                >
                  <FaArrowLeft />
                </button>{" "}
                <br></br>
                <h3 style={{ color: "#020c41" }}>
                  {levelUpName} - <span>Categorías</span>
                </h3>
                <input
                  type="text"
                  className="searchInput"
                  id="searchInput"
                  placeholder="Buscar..."
                />
                <button className="btnn" onClick={handleSearch}>
                  Buscar
                </button>
              </div>
              <div className="colum-rigth">
                <button className="btnn" onClick={createCategorie}>
                  Agregar Categoria
                </button>
              </div>
            </div>
            <table className="table table-preve">
              <thead>
                <tr>
                  <th>Categoría</th>
                  <td className="accions" style={{ width: "15%" }}>
                    Acciones
                  </td>
                </tr>
              </thead>
              <tbody>
                {category?.length > 0 ? (
                  category.map((c) => (
                    <tr key={c.id}>
                      <td>{c.name}</td>
                      <td>
                        <div className="order-actions">
                          <button
                            className="order-btn up"
                            onClick={() => moveItemUp(c.id, true)}
                            disabled={
                              category.findIndex((item) => item.id === c.id) ===
                              0
                            }
                            title="Mover arriba"
                          >
                            <FaArrowUp />
                          </button>
                          <button
                            className="order-btn down"
                            onClick={() => moveItemDown(c.id, true)}
                            disabled={
                              category.findIndex((item) => item.id === c.id) ===
                              category.length - 1
                            }
                            title="Mover abajo"
                          >
                            <FaArrowDown />
                          </button>
                          <button
                            className="order-btn position"
                            onClick={() => changePosition(c.id, true)}
                            title="Cambiar posición"
                          >
                            <FaArrowsAltV />
                          </button>
                        </div>
                        <FaEdit
                          className="editButton"
                          onClick={() => {
                            editCategorie(c.id);
                          }}
                          title="Editar"
                        />
                        <FaTimes
                          className="deleteButton"
                          onClick={() =>
                            deleteItem(
                              c.id,
                              "/api/qfa/category/delete",
                              "La categoría"
                            )
                          }
                          title="Eliminar"
                        />
                        <FaList
                          className="folderButton"
                          onClick={() => handleShowRequest(c.id, c.lgn, c.name)}
                          title="Ver preguntas"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No hay categorías para este nivel</td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        )}

        {/* Vista de preguntas y respuestas */}
        {vista === "preguntas" && (
          <>
            <div className="panel-table">
              <div className="colum-left">
                <button
                  onClick={handleBackView}
                  className="btnn"
                  style={{ marginBottom: "10px" }}
                >
                  <FaArrowLeft />
                </button>{" "}
                <br></br>
                <h3 style={{ color: "#020c41" }}>
                  {levelUpName} - {categoryName} - <span>Preguntas</span>
                </h3>
                <input
                  type="text"
                  className="searchInput"
                  id="searchInput"
                  placeholder="Buscar..."
                />
                <button className="btnn" onClick={handleSearch}>
                  Buscar
                </button>
              </div>
              <div className="colum-rigth">
                <button className="btnn" onClick={createRequesst}>
                  Agregar Pregunta
                </button>
              </div>
            </div>
            <table className="table table-preve">
              <thead>
                <tr>
                  <th>Pregunta</th>
                  <th>Respuesta</th>
                  <td className="accions" style={{ width: "15%" }}>
                    Acciones
                  </td>
                </tr>
              </thead>
              <tbody>
                {request?.length > 0 ? (
                  request.map((r) => (
                    <tr key={r.id}>
                      <td>{r.question}</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(r.answers),
                        }}
                      ></td>
                      <td>
                        <div className="order-actions">
                          <button
                            className="order-btn up"
                            onClick={() => moveItemUp(r.id, false)}
                            disabled={
                              request.findIndex((item) => item.id === r.id) ===
                              0
                            }
                            title="Mover arriba"
                          >
                            <FaArrowUp />
                          </button>
                          <button
                            className="order-btn down"
                            onClick={() => moveItemDown(r.id, false)}
                            disabled={
                              request.findIndex((item) => item.id === r.id) ===
                              request.length - 1
                            }
                            title="Mover abajo"
                          >
                            <FaArrowDown />
                          </button>
                          <button
                            className="order-btn position"
                            onClick={() => changePosition(r.id, false)}
                            title="Cambiar posición"
                          >
                            <FaArrowsAltV />
                          </button>
                        </div>
                        <FaEdit
                          className="editButton"
                          onClick={() => {
                            editRequesst(r.id);
                          }}
                          title="Editar"
                        />
                        <FaTimes
                          className="deleteButton"
                          onClick={() =>
                            deleteItem(
                              r.id,
                              "/api/qfa/question/delete",
                              "La pregunta"
                            )
                          }
                          title="Eliminar"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No hay preguntas en esta categoría.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        )}
      </div>

      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default Faq;
